import { cloneDeep, find } from 'lodash';

export const columnSettings = {
  name: {
    name: 'name',
    sort: 'asc',
    defaultSort: 'asc',
    displayName: 'LABEL_NAME'
  },
  url: {
    name: 'url',
    sort: 'asc',
    displayName: 'URL'
  },
  lastUsedAt: {
    name: 'lastUsedAt',
    sort: 'asc',
    displayName: 'LAST_USE'
  },
  status: {
    name: 'status',
    sort: 'asc',
    class: 'text-center col-sm-1',
    displayName: 'STATUS'
  }
};

export const defaultColumns = [
  'name',
  'url',
  'lastUsedAt',
  'status'
];


export default class AuthConnectionService {

  /**
   * @ngInject
   * @param {import('lodash').LoDashStatic} _ 
   * @param {import('angular').IHttpService} $http 
   * @param {*} authService 
   * @param {*} ngAuthSettings 
   */
  constructor(_, $http, authService, ngAuthSettings) {

    this.$http = $http;
    this.authService = authService;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.columnSettings = cloneDeep(columnSettings);
    this.defaultColumns = [...defaultColumns];
  }

  getAuthConnections(accountId) {
    const url = this.serviceBaseUri + accountId + '/AuthConnections';

    return this.$http.get(url);
  }

  getAuthConnection(accountId, authenticationId) {
    const url = this.#serviceBaseUrl(accountId, authenticationId);
    return this.$http.get(url);
  }

  
  getAuthConnectionReferences(accountId, authenticationId) {
    const url = this.#serviceBaseUrl(accountId, authenticationId) + '/InboundReferences';
    return this.$http.get(url);
  }

  createAuthConnection(accountId, authentication) {
    const url = this.serviceBaseUri + accountId + '/AuthConnections';
    return this.$http.post(url, authentication);
  }


  deleteAuthConnection(accountId, authenticationId, force) {
    const url = this.#serviceBaseUrl(accountId, authenticationId) + '?force=' + !!force;
    return this.$http.delete(url);
  }

  async updateAuthConnection(accountId, authentication) {
    const url = this.#serviceBaseUrl(accountId, authentication.id);
    return this.$http.patch(url, authentication);
  }

  async validateAuthConnection(accountId, authenticationId) {
    const url = this.#serviceBaseUrl(accountId, authenticationId) + '/Verify';
    return this.$http.patch(url);
  }

  #serviceBaseUrl(accountId, authenticationId) {
    return this.serviceBaseUri + accountId + '/AuthConnections/' + authenticationId;
  }

}